import ApiClient from './ApiClient';

class MotorReservaRatesAPI extends ApiClient {
  constructor() {
    super('motor_reserva_rates', { accountScoped: true });
  }
}

export default new MotorReservaRatesAPI();
